<template>
    <b-form-group :label="label" label-for="levels">
        <multiselect
            id="levels"
            :state="state"
            :selected="value"
            :options="levelsOptions"
            :multiple="multiple"
            :disabled="disabled"
            :placeholder="placeholder"
            :hideSelectedOptions="hideSelectedOptions"
            @changeValue="$emit('update:value', $event)"
        >
            <template slot="c-option" slot-scope="{ options: { option } }">
                <span>{{ option.label }}</span>
            </template>
        </multiselect>
    </b-form-group>
</template>

<script>
import defaultLevelOptions from '@/data/level'
import { Multiselect } from '@/views/components/selects'

export default {
    name: 'Levels',
    components: {
        Multiselect,
    },
    props: {
        value: {},
        state: {},
        disabled: {},
        label: {},
        hideSelectedOptions: {},
        placeholder: {
            type: String,
            default: null,
        },
        multiple: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            levelsOptions: defaultLevelOptions,
        }
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/CustomMultiselect.scss';

.c-th:hover {
    cursor: pointer;
}
</style>
